import { PROFESSIONAL } from 'self-service-api/constants/ProductLevels';
import { MARKETING } from 'self-service-api/constants/ProductLines';
import { useAppSelector } from '../../../reducers';
import { isUngatedForSeatsSelector } from '../../../selectors/GatingSelectors';
import { productForSkuIdSelector, skuIdIsHubSelector } from '../../../selectors/ProductsSelectors';
import { useIsPaidPortal } from '../../../v2/hooks/useProductInventory';

/**
 * A portal is eligible for the Free to Pro touchless flow if:
 * - It's a free portal
 * - They're purchasing a single hub at the Pro tier
 * - That single hub is not Marketing
 * @param productConfigurations
 * @returns
 */
const useIsEligibleForFreeToProTouchlessFlow = productConfigurations => {
  const {
    isPaidPortal,
    loading: isPaidPortalLoading
  } = useIsPaidPortal();
  return useAppSelector(state => {
    const isSeatsTBPortal = isUngatedForSeatsSelector(state);
    if (!isPaidPortalLoading && (isPaidPortal || !isSeatsTBPortal)) {
      return false;
    }
    const hubProductConfigs = productConfigurations.filter(config => skuIdIsHubSelector(state, {
      skuId: config.skuId
    }));
    if (hubProductConfigs.length !== 1) {
      return false;
    }
    const hubProductConfig = hubProductConfigs[0];
    const product = productForSkuIdSelector(state, {
      skuId: hubProductConfig.skuId
    });
    return product && product.productLine !== MARKETING && product.productLevel === PROFESSIONAL;
  });
};
export default useIsEligibleForFreeToProTouchlessFlow;